// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-submission-overflow[data-v-1b13e1ae]{height:180px;overflow-y:auto;overflow-x:hidden}.submission-overflow[data-v-1b13e1ae]{height:220px;overflow-y:auto;overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
